'use es6';

import ImmutablePropTypes from 'react-immutable-proptypes';
import { useState } from 'react';
import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import { EERIE, OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MobileCatalogSelector from './MobileCatalogSelector';
import PropTypes from 'prop-types';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CatMenuWrapper = styled(UIFlex).withConfig({
  displayName: "MobileCatalogMenu__CatMenuWrapper",
  componentId: "sc-8n8nzw-0"
})(["display:inline-flex;justify-content:center;width:auto;height:41px;margin-top:-10px;margin-bottom:-10px;"]);
const MenuLink = styled(UILink).withConfig({
  displayName: "MobileCatalogMenu__MenuLink",
  componentId: "sc-8n8nzw-1"
})(["display:inline-block;margin:5px 10px -5px;padding:10px;"]);
const MenuWrapper = styled.div.withConfig({
  displayName: "MobileCatalogMenu__MenuWrapper",
  componentId: "sc-8n8nzw-2"
})(["color:", ";text-align:left;"], OBSIDIAN);
const MobileCatalogMenu = ({
  categories,
  hsSoftwareCategories,
  inlineLink,
  buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.heading.headingLinks.browseCatalog`
  }),
  selectedFilterType,
  selectedGroup
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const LinkComponent = inlineLink ? UILink : MenuLink;
  return /*#__PURE__*/_jsxs(CatMenuWrapper, {
    align: 'center',
    children: [/*#__PURE__*/_jsx(LinkComponent, {
      "data-test-id": "category-selector-panel-button",
      onClick: () => {
        setMenuOpen(true);
      },
      use: inlineLink ? 'blue' : 'on-dark',
      children: buttonText
    }), inlineLink && /*#__PURE__*/_jsx(UIIcon, {
      className: 'm-left-1',
      color: EERIE,
      name: "downCarat",
      size: 10
    }), /*#__PURE__*/_jsx(MenuWrapper, {
      children: /*#__PURE__*/_jsx(MobileCatalogSelector, {
        categories: categories,
        "data-test-id": "mobile-category-selector-panel",
        hsSoftwareCategories: hsSoftwareCategories,
        menuOpen: menuOpen,
        selectedFilterType: selectedFilterType,
        selectedGroup: selectedGroup,
        setMenuOpen: setMenuOpen
      })
    })]
  });
};
MobileCatalogMenu.propTypes = {
  buttonText: PropTypes.node,
  categories: ImmutablePropTypes.map.isRequired,
  hsSoftwareCategories: ImmutablePropTypes.map.isRequired,
  inlineLink: PropTypes.bool,
  selectedFilterType: PropTypes.string,
  selectedGroup: PropTypes.string
};
export default MobileCatalogMenu;